import { AnimationView as ReactAnimationView } from 'src/views/menus/animation';
import { initiateAnimationPreview } from 'src/views/menus/animation/sidebarAnimation';

module.exports = Backbone.View.extend({
  isInitialized: false,

  render () {
    initiateAnimationPreview();

    this.$el.html(`
      <div class="animations-app"></div>
      <sidebar-animation-preview></sidebar-animation-preview>
    `);

    if (!INKIVE.C.IS_MOBILE_APP && !INKIVE.C.IS_MOBILE) {
      ReactAnimationView.mountApp();
    }

    this.isInitialized = true;
  },

  show () {
    if (!this.isInitialized) {
      this.render();
    }
  }
});
